/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Fw_Kits_AppliedInputs */

const en_fw_kits_applied = /** @type {(inputs: Fw_Kits_AppliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kit applied: ${i?.title}`)
};

const id_fw_kits_applied = /** @type {(inputs: Fw_Kits_AppliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kit dipakai: ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Kit applied: {title}" |
*
* @param {Fw_Kits_AppliedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_kits_applied = /** @type {((inputs: Fw_Kits_AppliedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Kits_AppliedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_kits_applied(inputs)
	return en_fw_kits_applied(inputs)
});